import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import styled from '@emotion/styled'
import { css } from "@emotion/react"
import { useDispatch, useSelector } from "react-redux"

// actions
import { openDrawer, closeDrawer, toggleDrawer } from '~/slices/commons/drawer'

// components
import RoundedCornersButton from "../../../atoms/roundedCornersButton"
import SearchDrawer from "./searchDrawer";
import CartDrawer from "./cartDrawer";
import HeaderDrawer from './menuDrawer'
import SnackBar from './SnackBar'

// setting
import colorPalette from "../../../../styles/theme/colorPalette"

// resources
import LogoPath from '../../../../../public/images/common/logo.svg'
import IconSearchPath from '../../../../../public/images/common/icon_search.svg'
import IconCartPath from '../../../../../public/images/common/icon_shop.svg'
import IconMenuPath from '../../../../../public/images/common/icon_menu.svg'
import {Button} from "@material-ui/core";
import {useTheme} from "@material-ui/core/styles";
import {makeStyles} from "@material-ui/styles";
import NeutralButton from "../../../atoms/NeutralButton";
import {Box} from "@mui/material";
import Grid from "@material-ui/core/Grid";

const HeaderNavigation = (props) => {
  const theme = useTheme()
  const useStyles = makeStyles({
    root: {
      [theme.breakpoints.up('md')]: {
        width: '100%',
      },
      [theme.breakpoints.up('xl')]: {
        width: '960px',
        margin: '0 auto',
      },
    },
  })
  const classes = useStyles()

  // サインインしていたらtrue
  // falseの場合、会員登録／ログインのボタンをナビゲーション下に表示する
  const signIn = useSelector((state) => state.login.login)

  const drawerState = useSelector((state) => state.drawer)
  const { openFlg, key } = drawerState
  const dispatch = useDispatch()
  
  const cartState = useSelector((state) => state.cart)
  const sumItemNum = (sum, current) => {
    return sum += current.num
  }

  return (
    <div >
      <Navigation>
        <NavInner className={classes.root}>
          <Logo>
            <Link href={'/'}>
              <a>
                {/*<Image src={LogoPath} alt='ミールタイムロゴ'/>*/}
                <LogoPath fill={'#d0121b'} />
              </a>
            </Link>
          </Logo>
          <IconWrapper>
            <Icon isActive={openFlg && key == 'search'} onClick={() => dispatch(toggleDrawer({openFlg: key == 'search' ? !openFlg : true, key: 'search'})) }>
              <IconSearchPath fill={openFlg && key == 'search' ? 'white' : 'black'} />
            </Icon>
            <Icon isActive={openFlg && key == 'cart'} onClick={() => dispatch(toggleDrawer({openFlg: key == 'cart' ? !openFlg : true, key: 'cart'})) }>
              {/*<Image src={IconCartPath} alt='カートアイコン'/>*/}
              {
                cartState.lines.length > 0 && cartState.lines[0].code &&
                <div css={cartBadge}><span>{ cartState.lines.reduce(sumItemNum,0) }</span></div>
              }
              <IconCartPath fill={openFlg && key == 'cart' ? 'white' : 'black'} />
            </Icon>
            <Icon isActive={openFlg && key == 'main'} onClick={() => dispatch(toggleDrawer({openFlg: key == 'main' ? !openFlg : true, key: 'main'})) }>
              {/*<Image src={IconMenuPath} alt='メニューアイコン'/>*/}
              <IconMenuPath fill={openFlg && key == 'main' ? 'white' : 'black'} />
            </Icon>
          </IconWrapper>
        </NavInner>
        {
          !signIn &&
          <NavRegister>
            <Grid container spacing={2} flexDirection={'row'} alignItems={'center'} justifyContent={'center'}>
              <Grid item>
                <Link href={'/login'}>
                  <a>
                    <NeutralButton
                        text={'ログイン'}
                        minWidth={'120px'}
                        maxWidth={'140px'}
                        css={{padding: '0.5rem'}}
                        hexColorCode={colorPalette.gray}
                        onClick={() => dispatch(toggleDrawer({openFlg: false, key: 'main'}))}/>
                  </a>
                </Link>
              </Grid>
              <Grid item>
                <Link href={'/signup'}>
                  <a>
                    <NeutralButton
                        text={'会員登録'}
                        minWidth={'120px'}
                        maxWidth={'140px'}
                        css={{padding: '0.5rem'}}
                        onClick={() => dispatch(toggleDrawer({openFlg: false, key: 'main'}))}/>
                  </a>
                </Link>
              </Grid>
            </Grid>
          </NavRegister>
        }
      </Navigation>
      <SearchDrawer isSpacer={!signIn}/>
      <CartDrawer isSpacer={!signIn}/>
      <HeaderDrawer isSpacer={!signIn}/>
      <SnackBar />
      {
        props.spacer &&
        <NavMargin signin={signIn} />
      }
    </div>
  )
}

export default HeaderNavigation;

let Logo = styled.div({
  maxWidth: '104px',
  marginLeft: '16px',
  marginTop: '8px',
  '& svg': {
    width: '100%',
  },
})

let Icon = styled.div({
    padding: '8px',
    display: 'inherit',
    maxWidth: '64px',
    maxHeight: '64px',
    position: 'relative',
    '& svg': {
      width: '100%',
    },
  },
  props => ({
    //background: props.isActive ? colorPalette.primaryGradient.rgb : 'initial',
    background: props.isActive ? colorPalette.primaryGradient.gradient : 'initial',
  })
)

let IconWrapper = styled.div({
  display: 'flex',
})

let NavInner = styled.div ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
})

let Navigation = styled.div({
  position: 'fixed',
  top: '0',
  textAlign: 'center',
  width: '100vw',
  zIndex: '100',
  backgroundColor: 'rgba(255,255,255,0.7)',
  backdropFilter: 'blur(4px)',
  boxShadow: '0 0 10px 5px rgb(0 0 0 / 4%)',
})

let NavMargin = styled.div({
},props => ({
  height: props.signin ? '80px' : '122px'
}))

let NavRegister = styled.div({
  margin: '8px 0',
  '& a': {
    minWidth: '144px',
    textDecoration: 'none',
  }
})


const cartBadge = css`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  width: 18px;
  height: 18px;
  border-radius: 20px;
  background-color: ${colorPalette.primary};
  color: white;
  right: 14px;
  font-weight: bold;
`